import React from 'react';
import { useActions } from '../../hooks/useActions';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import NavContainer from '../UI/Navbar/NavContainer';
import { adminNav } from '../UI/Navbar/NavContainer.data';

const Navbar: React.FC = () => {
  const { logout } = useActions();
  const { user } = useTypedSelector((state) => state.auth);

  const exit = () => {
    logout();
  };

  if (user.role) {
    return (
      <NavContainer
        name={user.name}
        leftData={adminNav}
        exit={exit}
        avatarPath={user.avatar ? user.avatar : ''}
        role={user.role}
      />
    );
  }
  return <div></div>;
};

export default Navbar;
